import type { IconName } from '@/components/common/Icon';

export interface FilePreviewTarget {
  fileId: string;
  url: string;
  filename: string;
  contentType: string;
}

export function resolveFileIcon(contentType: string): IconName {
  if (contentType.startsWith('image/')) {
    return 'Image';
  }
  if (contentType.startsWith('video/')) {
    return 'Video';
  }
  return 'FileText';
}
